import gql from "graphql-tag";
import {FetchResult} from "apollo-link"
import {client} from "./client";
import {IEntityNode} from "../types";
import {UpdateEntityByFullUid} from "../../schema/UpdateEntityByFullUid";

const getMutation = (fullUid: string, patchObject: {[key: string]: any}): any => ({
    mutation: gql`${UpdateEntityByFullUid}`,
    variables: {
        fullUid,
        patchObject,
    }
});

export async function updateEntityByFullUid (fullUid: string, entityPatchObject: {[key: string]: any}):
    Promise<IEntityNode> {
    const result: FetchResult<{ updateEntityByFullUid: { entity: IEntityNode } }> = await client.mutate(getMutation(fullUid, entityPatchObject));
    const {entity} = result.data?.updateEntityByFullUid!;
    if (!entity) {
        throw new Error('failed to update entity');
    } else {
        client.cache.reset();
        return entity;
    }
}
